// Duas formas de carimbo convivem na API, e a diferenca entre elas e de 3 HORAS:
//
//   1. SEM FUSO — "2026-07-21 10:16:37.919835". Vem das colunas `timestamp without time
//      zone` que ainda faltam converter na onda do fuso ([DA-330]). Os digitos sao o
//      relogio de Brasilia; o JS os leria como UTC. Aqui a gente reinterpreta somando 3h.
//   2. COM FUSO — "2026-07-21 09:31:36.138323-03" ou "2026-07-20T18:02:01.419Z". Vem das
//      colunas ja convertidas pra `timestamptz`. O instante ja esta CERTO e o `new Date`
//      do JS entende as duas grafias. Somar 3h aqui adianta a tela em 3 horas.
//
// Quem decide a grafia e a rota, nao a coluna: consulta em SQL cru devolve o texto do
// Postgres (com o `-03` junto), consulta pelo Drizzle devolve um Date que o JSON serializa
// em UTC com `Z`. Por isso o teste e pelo SUFIXO da string, nunca pela tabela de origem.
//
// O sintoma de quando isso quebrou (2026-07-21): cliente cadastrado 15:02 aparecia 18:02.
export function parseSPDate(val: string | Date | null | undefined): Date | null {
  if (!val) return null;
  if (val instanceof Date) return val;
  const s = String(val);
  // Data pura "YYYY-MM-DD" sem horário: new Date("YYYY-MM-DD") usa meia-noite UTC
  // e no fuso SP (UTC-3) vira o dia anterior. Tratar como meio-dia local.
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, mo, d] = s.split('-').map(Number);
    return new Date(y!, mo! - 1, d!, 12, 0, 0);
  }
  // Carimbo COM fuso explicito: o instante ja esta certo, so parsear.
  if (/(?:[Zz]|[+-]\d{2}(?::?\d{2})?)$/.test(s)) return new Date(s);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
  if (!m) return new Date(val);
  return new Date(Date.UTC(+m[1]!, +m[2]! - 1, +m[3]!, +m[4]! + 3, +m[5]!, +m[6]!));
}

export function formatDataSP(val: string | Date | null | undefined): string {
  const d = parseSPDate(val);
  if (!d) return '—';
  return d.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}

export function formatDataHoraSP(val: string | Date | null | undefined): string {
  const d = parseSPDate(val);
  if (!d) return '—';
  return d.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}

export function formatHoraSP(val: string | Date | null | undefined): string {
  const d = parseSPDate(val);
  if (!d) return '—';
  return d.toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit' });
}
